module.exports = __webpack_public_path__ + "static/profilbw-4b07f9ad3746ababccc29e5abdd1be3a.png";